import { GtmEvents } from '@/gtm/gtm-events';

export class ProductKitGtmEvents extends GtmEvents {
  eventCategory = 'СобытияВКарточке';

  isKitWasShown = false;

  onShownGoToKitBlock() {
    this.gtmEvent({
      eventAction: 'КРТ_Комплект_СмотретьКомплект_Показ',
    });
  }

  onClickToKitBlock() {
    this.gtmEvent({
      eventAction: 'КРТ_Комплект_СмотретьКомплект_Клик',
    });
  }

  onClickKitTab() {
    this.gtmEvent({
      eventAction: 'КРТ_Комплект_КликПоВкладке',
    });
  }

  onShownKit() {
    if (this.isKitWasShown) {
      return;
    }

    this.gtmEvent({
      eventAction: 'КРТ_Комплект_Показ',
    });

    this.isKitWasShown = true;
  }

  onChangeKit() {
    this.gtmEvent({
      eventAction: 'КРТ_Комплект_СменаКомплекта',
    });
  }

  onAddKit(isAllAdded) {
    this.gtmEvent({
      eventAction: 'КРТ_Комплект_ДобавленВКорзину',
      eventLabel: JSON.stringify({
        all_complect: isAllAdded,
      }),
    });
  }
}
